import { Model } from '@vuex-orm/core'

export default class Requisition extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'requisitions'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      code: this.attr(null),
      status: this.attr(null),
      title: this.attr(null),
      template: this.attr(null),
      description: this.attr(null),
      requirements: this.attr(null),
      benefits: this.attr(null),
      comments: this.attr(null),
      openings: this.attr(null),
      currency: this.attr(null),
      remuneration: this.attr(null),
      remuneration_max: this.attr(null),
      remuneration_period: this.attr(null),
      requisition_keywords: this.attr(null),
      confidential: this.attr(null),
      country: this.attr(null),
      region: this.attr(null),
      city: this.attr(null),
      neighborhood: this.attr(null),
      address: this.attr(null),
      zipcode: this.attr(null),
      workplace_type: this.attr(null),
      hiring_manager_name: this.attr(null),
      hiring_manager_email: this.attr(null),
      company_id: this.attr(null),
      departament_id: this.attr(null),
      contract_id: this.attr(null),
      owner_user_id: this.attr(null),
      position_category: this.attr(null),
      experience_level: this.attr(null),
      education_degree: this.attr(null),
      custom_fields: this.attr(null),
      approvalflow: this.attr(null),
      job: this.attr(null),
      followers: this.attr(null),
      author_user_id: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Requisition.js